import * as AppConfigurationModule from './AppConfiguration/store';
import * as AuthModule from './Authentication/store/index';
import * as CultureCardModule from './CultureCard/store';
import * as DashboardModule from './Dashboard/store';
import * as EndUsersManagementModule from './EndUsersManagement/store';
import * as LiveSessionCardModule from './LiveSessionCard/store';
import * as MailModule from './Mail/store';
import * as NotificationModule from './Notification/store';
import * as QuestionModule from './OnboardingQuestion/store';
import * as RegionsConfigurationModule from './RegionsConfiguration/store';
import * as SceneMatchingModule from './SceneMatching/store';
import * as SentenceModule from './Sentence/store';
import * as ShopModule from './Shop/store';

const activeModules = [
	AuthModule.moduleInstance,
	DashboardModule.moduleInstance,
	EndUsersManagementModule.moduleInstance,
	QuestionModule.moduleInstance,
	RegionsConfigurationModule.moduleInstance,
	AppConfigurationModule.moduleInstance,
	CultureCardModule.moduleInstance,
	LiveSessionCardModule.moduleInstance,
	ShopModule.moduleInstance,
	NotificationModule.moduleInstance,
	MailModule.moduleInstance,
	SentenceModule.moduleInstance,
	SceneMatchingModule.moduleInstance,
];

export default activeModules;
